import {
  booleanAttribute,
  Component,
  EventEmitter,
  inject,
  Input,
  numberAttribute,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { IonButton, IonButtons, IonIcon } from '@ionic/angular';

import { DiscussionStepperComponentStore } from './discussion-stepper.store';

@Component({
  selector: 'nty-discussion-form-stepper',
  imports: [IonButton, IonButtons, IonIcon],
  template: `
    <ion-buttons slot="start">
      <!-- Back -->
      <ion-button shape="round" size="small" (click)="stepperStore.onBack()">
        <ion-icon slot="icon-only" name="chevron-back-outline" />
      </ion-button>

      <span class="stepper-counter">{{ currentSectionNumber }} of {{ sectionCount }}</span>

      <!-- Next -->
      <ion-button shape="round" size="small" (click)="stepperStore.onNext()">
        <ion-icon slot="icon-only" name="chevron-forward-outline" />
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <div class="cta-content">
        @if (!readonly) {
          <!-- Save For Later -->
          <ion-button id="discussion-save-btn" shape="round" size="small" (click)="saveForLater.emit()">
            <ion-icon slot="icon-only" src="assets/icons/save--regular.svg" />
          </ion-button>

          <!-- Finish -->
          <ion-button
            id="discussion-finish-btn"
            shape="round"
            class="finish-button"
            fill="solid"
            [disabled]="disableFinish"
            (click)="finished.emit()">
            <ion-icon slot="start" name="checkmark-outline" />
            Finish
          </ion-button>
        }
      </div>
    </ion-buttons>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    @use 'terra';

    :host {
      display: flex;
      justify-content: space-between;
    }

    div.cta-content {
      display: flex;
      gap: 8px;
    }

    .stepper-counter {
      @include terra.text(body);
      color: terra.color(text);
      display: inline-block;
      margin: 0 8px;
    }

    ion-button:not(.finish-button) {
      --background: #{terra.color(background)};

      --color: #{terra.color(text, light)};

      --border-radius: 50%;
      --border-color: #{terra.color(border)};
      --border-style: solid;
      --border-width: 1px;

      --padding-top: 10px;
      --padding-bottom: 10px;

      width: 42px;
      height: 42px;
    }

    ion-button.finish-button {
      --background: #{terra.color(neutral-heavy, 500)};
      --color: #{terra.color(text-invert)};
      --padding-start: 12px;
      --padding-end: 12px;
      --padding-top: 6px;
      --padding-bottom: 6px;

      @include terra.text(body);
    }
  `,
})
export class DiscussionFormStepperComponent {
  stepperStore = inject(DiscussionStepperComponentStore);

  @Input({ required: true, transform: booleanAttribute }) readonly = true;
  @Input({ required: true, transform: booleanAttribute }) disableFinish = true;
  @Input({ required: true, transform: numberAttribute }) currentSectionNumber = 0;
  @Input({ required: true, transform: numberAttribute }) sectionCount = 0;

  @Output() saveForLater = new EventEmitter<void>();
  @Output() finished = new EventEmitter<void>();
}
